import Reveal from '@/pages/zz-review/components/Reveal';

const steps = [
  { n: '01', title: '停', body: '在情緒、壓力或衝突升起的第一時間停下來。' },
  { n: '02', title: '帶著覺知，腹式深呼吸', body: '先讓身體回來，再讓本心參與決定。' },
  { n: '03', title: '不讓舊慣性替你作完決定', body: '把自動反應，轉成自主清明的選擇。' },
];

const practices = [
  {
    icon: 'ri-git-branch-line',
    title: '辨識意識根系',
    body: '理解自己為什麼在特定壓力下反覆失去焦點，不再只用自責或意志力解釋一切。',
    accent: false,
  },
  {
    icon: 'ri-compass-3-line',
    title: '整合身心意行四軸',
    body: '從身體、心智、意向與行動重新對齊，讓所知、所願與所作逐步一致。',
    accent: false,
  },
  {
    icon: 'ri-seedling-line',
    title: '開始一年築基',
    body: '書本提供地圖與第一次練習；真正的能力需要在一年的日常事件中累積。',
    accent: false,
  },
  {
    icon: 'ri-file-chart-line',
    title: '將成長留下 Evidence',
    body: '不只記錄心情，而是依照 Portal 七項短紀錄，回看觸發事件、身體與實物、情緒與能量、自動念頭、可能根系、四軸缺口，以及本次上升點。',
    accent: false,
  },
  {
    icon: 'ri-eye-2-line',
    title: '讓 AI 成為鏡子，不是主人',
    body: 'RG Portal 協助讀者整理事件與練習記錄，讓科技支持本心，而不是代替人為自己負責。',
    accent: true,
  },
];

export default function ConceptsSection() {
  return (
    <section id="concepts" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-12">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              本書內容
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              五秒智慧：先不讓舊慣性替你作完決定
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-2xl mx-auto">
              五秒不是快速思考技巧，而是一個最小的回歸入口。在情緒、壓力或衝突升起時，先讓身體回來，再讓本心參與決定。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-12">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 80}>
              <div className="h-full rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-7 flex flex-col">
                <span className="text-xs font-medium text-primary-700 mb-4">{s.n}</span>
                <h3
                  className="text-lg md:text-xl text-foreground-900 mb-3"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {s.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={60}>
          <div className="rounded-lg border border-background-200/70 bg-background-100 px-6 md:px-10 py-8 text-center mb-12">
            <h3
              className="text-xl md:text-2xl text-foreground-900 mb-4"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              不逃離人間：帶著肉身、工作與關係一起成長
            </h3>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl mx-auto">
              歷史上，很多精神探索走向避世與抽離。《1001旋轉門》選擇另一條路：不否定身體，不放棄家庭，不逃避工作與金錢，也不把生命成長停在美好的感覺。我們把「具身進化」理解為：更能照顧身體、修補關係、完成交付、承擔後果、創新價值，並在力量擴大之後依然不失去中軸。
            </p>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="text-center mb-8">
            <h3
              className="text-xl md:text-2xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              這本書會陪你做什麼？
            </h3>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {practices.map((p, i) => (
            <Reveal key={p.title} delay={i * 60}>
              <div
                className={`h-full rounded-lg border p-6 md:p-7 flex flex-col ${
                  p.accent
                    ? 'border-accent-200/70 bg-accent-50'
                    : 'border-background-200/70 bg-background-100'
                }`}
              >
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded-md mb-5 ${
                    p.accent
                      ? 'bg-accent-100 text-accent-800'
                      : 'bg-primary-100 text-primary-800'
                  }`}
                >
                  <i className={`${p.icon} text-2xl`} />
                </div>
                <h4
                  className="text-base md:text-lg text-foreground-900 mb-3"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {p.title}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}